import React from 'react';
import './States.css';

interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ message = 'Не удалось загрузить данные', onRetry }) => (
  <div className="state-block error-state">
    <div className="state-icon">!</div>
    <p className="state-title">{message}</p>
    {onRetry && (
      <button className="state-action" onClick={onRetry}>
        Повторить
      </button>
    )}
  </div>
);

interface EmptyStateProps {
  icon?: string;
  title: string;
  hint?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon = '—',
  title,
  hint,
  actionLabel,
  onAction
}) => (
  <div className="state-block empty-state">
    <div className="state-icon">{icon}</div>
    <p className="state-title">{title}</p>
    {hint && <p className="state-hint">{hint}</p>}
    {actionLabel && onAction && (
      <button className="state-action" onClick={onAction}>
        {actionLabel}
      </button>
    )}
  </div>
);

interface LoadingStateProps {
  text?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ text = 'Загрузка…' }) => (
  <div className="state-block loading-state">
    <div className="state-spinner" aria-hidden="true" />
    <p className="state-title">{text}</p>
  </div>
);
